import React, { FC } from 'react';
import BottomSheet from '@/components/Common/DesignSystem/BottomSheet/BottomSheet';
import styles from './index.module.scss';

interface NolNoticeBottomSheetProps {
  title: string | React.ReactNode;
  isOpen: boolean;
  onRequestClose: () => void;
}

const NolNoticeBottomSheet: FC<NolNoticeBottomSheetProps> = ({ title, isOpen, onRequestClose, children }) => {
  return (
    <BottomSheet isOpen={isOpen} onRequestClose={onRequestClose}>
      {{
        title: <div className={styles.title}>{title}</div>,
        body: <div className={styles.container}>{children}</div>,
        buttons: {
          type: 'confirm',
          style: 'basic',
          label: '닫기',
          onClick: onRequestClose,
        },
      }}
    </BottomSheet>
  );
};

export default NolNoticeBottomSheet;
